import React from 'react';
import { Layers } from 'lucide-react';
export const CombinedPricing = () => {
  return <div className="py-20 lg:py-24 bg-gray50 min-h-[calc(100vh-300px)]" data-id="element-451">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-452">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-453">
          <div className="w-20 h-20 bg-brandRed/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-454">
            <Layers className="w-10 h-10 text-brandRed" data-id="element-455" />
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-456">
            Combined Quantity Pricing
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-457">
            Maximize your margins by combining different items to reach higher
            discount tiers.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl border border-gray200 shadow-sm" data-id="element-458">
          <h2 className="text-2xl font-bold text-ink mb-6" data-id="element-459">How It Works</h2>
          <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-460">
            Unlike traditional manufacturers that price each item separately, we
            allow dealers to combine quantities across an entire order package
            to unlock better pricing.
          </p>

          <div className="bg-gray50 p-6 rounded-xl border border-gray200 mb-8" data-id="element-461">
            <h3 className="font-bold text-ink mb-4 text-lg" data-id="element-462">
              Example Scenario
            </h3>
            <div className="flex flex-col md:flex-row gap-6 items-center justify-center" data-id="element-463">
              <div className="text-center" data-id="element-464">
                <div className="text-3xl font-bold text-brandRed mb-1" data-id="element-465">100</div>
                <div className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-466">
                  Jerseys
                </div>
              </div>
              <div className="text-2xl text-gray-400 font-bold" data-id="element-467">+</div>
              <div className="text-center" data-id="element-468">
                <div className="text-3xl font-bold text-brandRed mb-1" data-id="element-469">100</div>
                <div className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-470">
                  Shorts
                </div>
              </div>
              <div className="text-2xl text-gray-400 font-bold" data-id="element-471">=</div>
              <div className="text-center" data-id="element-472">
                <div className="text-3xl font-bold text-ink mb-1" data-id="element-473">200</div>
                <div className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-474">
                  Piece Pricing Tier
                </div>
              </div>
            </div>
          </div>

          <p className="text-gray-600 leading-relaxed" data-id="element-475">
            This structure is designed specifically to help dealers quote full
            team packages more competitively and win more bids.
          </p>
        </div>
      </div>
    </div>;
};